import moment from 'moment-timezone';

import { EventsFilter } from '../interfaces';
import { EventTypeIdentifier, VideoStatus } from '../enums';

const fleetToFilterMap = new Map<number, Partial<EventsFilter>>([
  [
    1, // MTA
    {
      dateFrom: moment().subtract(7, 'day').startOf('day').toISOString(),
      dateTo: moment().toISOString(),
      selectedFilters: [EventTypeIdentifier.BUS_LANE_MATCH],
      human_review: true,
      media_statuses: [VideoStatus.publishedStr],
      whitelist: false,
    } as Partial<EventsFilter>,
  ],
  [
    40, // MTA Replay
    {
      dateFrom: moment().subtract(7, 'day').startOf('day').toISOString(),
      dateTo: moment().toISOString(),
      selectedFilters: [EventTypeIdentifier.BUS_LANE_MATCH],
      human_review: true,
      media_statuses: [VideoStatus.publishedStr],
      whitelist: false,
    } as Partial<EventsFilter>,
  ],
  [
    2256, // SacRT Bus Stop Shelter
    {
      dateFrom: moment().subtract(24, 'hours').toISOString(),
      dateTo: moment().toISOString(),
      include_tags: true,
      tag_operator: 'or',
      tags: {
        'td:776': 'ev:2233', // Graffiti SacRT bus stop shelter tags
        'td:772': 'ev:2230', // 'Sign missing/faded',
        'td:781': 'ev:2238', // 'Faded / missing advertisements',
        'td:774': 'ev:2231', // 'Pole is broken / missing',
        'td:775': 'ev:2232', // 'Broken glass',
        'td:777': 'ev:2234', // 'Lights out',
        'td:778': 'ev:2235', // 'Garbage overflow',
        // 'td:779': 'ev:2236', // 'Good condition',
        'td:780': 'ev:2237', // 'Other',
        'td:814': 'ev:2271', // Unattended Personal Property
      },
    },
  ],
]);

const cleanFilterToFleet = new Map<number, Partial<EventsFilter>>([
  [
    2256, // SacRT Bus Stop Shelter
    {
      include_tags: true,
    },
  ],
]);

export const defaultFilter: EventsFilter = {
  // Events filtering default setting for the Slider,
  // Defines from how many hours from the past the Events should be
  // fetched.
  dateFrom: moment().subtract(1, 'week').startOf('day').toISOString(),
  dateTo: moment().toISOString(),

  // Selected tags for filtering, their identifiers
  selectedFilters: [],

  // Selected license plates
  license_plates: [],

  time_of_day: [0, 24],

  vehicle_types: [],
  active_lanes: [],

  route_ids: [],
  vehicle_ids: [],
  bus_stop_ids: [],
  device_ids: [],
};

export const fleetDefaultFilters = (fleetId: number): EventsFilter => {
  if (fleetToFilterMap.has(fleetId)) {
    return { ...defaultFilter, ...fleetToFilterMap.get(fleetId) };
  }
  return { ...defaultFilter };
};

export const fleetCleanFilters = (fleetId: number): EventsFilter => {
  const overrides = cleanFilterToFleet.get(fleetId);
  return { ...defaultFilter, ...overrides };
};
